import React from 'react';
import currency from 'currency.js';
import pt from 'prop-types';
import cn from 'classnames';
import Modal from './Modal';
import reviewStyles from './ReviewModal.module.scss';
import styles from './ExtraPoseConfirmModal.module.scss';

// TODO: The additionalPoses count needs to be updated when editing. The initial value is incorrect.

export default function ExtraPoseConfirmModal({
  additionalPoses,
  isOpen,
  setIsOpen,
  onConfirm: handleConfirm,
  option,
}) {
  const onConfirm = () => {
    setIsOpen(false);
    handleConfirm();
  };

  const onCancel = () => setIsOpen(false);

  return (
    <Modal>
      <Modal.Content isOpen={isOpen} className={cn(reviewStyles.content, styles.content)}>
        <div>
          <div>
            <div className={reviewStyles.headerWrapper}>
              <Modal.Title className={reviewStyles.title}>Add Extra Pose?</Modal.Title>
              <button className={reviewStyles.close} onClick={() => setIsOpen(false)}>X</button>
            </div>
            <p className={styles.msg}>
              {`Adding an extra pose will add an additional ${currency(option.additionalPoseCharge).format()} 
              to your package per pose. The package you selected allows ${option.poses} poses.`}
            </p>
            <p className={styles.quantityMsg}>
              {`(${additionalPoses} extra added currently)`}
            </p>
            <div className={reviewStyles.footer}>
              <button onClick={onConfirm} type="button">Confirm</button>
              <button onClick={onCancel} type="button">Cancel</button>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
}

ExtraPoseConfirmModal.propTypes = {
  additionalPoses: pt.number.isRequired,
  isOpen: pt.bool.isRequired,
  setIsOpen: pt.func.isRequired,
  onConfirm: pt.func.isRequired,
  option: pt.shape({
    additionalPoseCharge: pt.number.isRequired,
    poses: pt.number.isRequired,
  }).isRequired,
};
